__turbopack_context__.v({
  "dropdownContainer": "styles-module__LXhY3a__dropdownContainer",
  "dropdownList": "styles-module__LXhY3a__dropdownList",
  "dropdownListHorizontal": "styles-module__LXhY3a__dropdownListHorizontal",
});
